module.exports = __webpack_public_path__ + "img/404.52a3a378.svg";